// src/pages/SchoolListPage.jsx
import React from "react";
import SchoolListLayer from "../components/school/SchoolListLayer";
import MasterLayout from "../masterLayout/MasterLayout";

export const SchoolListPage = () => {
  return (
    <MasterLayout>
      <SchoolListLayer />
    </MasterLayout>
  );
};

export default SchoolListPage;
